module.exports = __webpack_public_path__ + "static/durriya-fc3572691d6b7fa946c1937ea0a428ad.jpg";